import PlatesSelect from './PlatesSelect';
import './PlatesSelect.scss';

export default PlatesSelect;